import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "stores/auth/authStore";
import { useCartStore } from "stores/cart/useCartStore";
import MegaMenu from "../../MegeMenu";
import { shouldHideGradient } from "utils/gradientconfig";
import Logo from "./logo";
import DesktopNavigation from "./desktopNavigation";
import MdScreenButtons from "./mdScreenButtons";
import ToggleMobileMenu from "./toggleMobileMenu";
import { Modal, useModalStore } from "stores/modal/useModalStore";
import { LIST_SADDLE_FAVORITES } from "apollo/queries/saddleFavorite";
import { gql, useQuery } from "@apollo/client";

const Header = () => {
  const open = useModalStore((s) => s.open);
  const user = useAuthStore((state) => state.user);
  const toggle = useAuthStore((state) => state.toggle);
  const setToggle = useAuthStore((state) => state.setToggle);
  const reset = useAuthStore((state) => state.reset);
  const setIsAction = useAuthStore((state) => state.setIsAction);
  const setIsOpen = useAuthStore((state) => state.setIsOpen);
  const fetchCartData = useCartStore((action => action.fetchCartData));
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const navRef = useRef(null);
  const timeoutRef = useRef(null);

  const navigate = useNavigate();
  let location = useLocation();
  const subdomain = useAuthStore((state) => state.domain);
  
  const hideGradientColor = shouldHideGradient(location.pathname) || subdomain;

  const { data: favouriteSaddleData } = useQuery(gql(LIST_SADDLE_FAVORITES), {
    skip: !user,
    fetchPolicy: "network-only"
  });

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShowMegaMenu(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowMegaMenu(false);
    }, 200);
  };

  const onSignUpHandler = async () => {
    if (toggle) setToggle(true);
    navigate("/signup", {
      state: { backgroundLocation: location },
    });
  };

  const onSignInHandler = async () => {
    if (toggle) setToggle(false);
    open(Modal.Login);
  };

  const onSignOutHandler = async () => {
    try {
      setToggle(false);
      await signOut();
      setIsAction(null);
      setIsOpen(false);
      reset();
      navigate("/");
      localStorage.removeItem(`cart${user?.sub}`);
    } catch (error) {
      console.log(error, "error");
     }
  };

  useEffect(() => {
    if (user) fetchCartData();
  }, [user, fetchCartData]);

  useEffect(() => {
    if (toggle) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [toggle]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navRef.current &&
        !navRef.current.contains(event.target) &&
        !event.target.closest(".menu-icon")
      ) {
        setToggle(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setToggle]);

  return (
    <>
      {/* Apply hide_gradient class when gradient should be hidden */}
      <div
        className={`${hideGradientColor ? "hide_gradient" : "gradient h-[94px]"} `}
      />

      <div
        className={
          hideGradientColor
            ? "hide_gradient z-30"
            : `left-0 right-0 z-30 
            ${toggle ? "fixed bg-[#2B364B]" : "absolute"
            } top-[0px] z-10 lg:bg-transparent `
        }
      >
        <div className="w-full py-5 px-6">
          <div className="flex w-[95%] xl:max-w-[1300px] sm:mx-auto justify-between  items-center">
            <Logo />
            <DesktopNavigation
              handleMouseEnter={handleMouseEnter}
              handleMouseLeave={handleMouseLeave}
              onSignUpHandler={onSignUpHandler}
              onSignInHandler={onSignInHandler}
              onSignOutHandler={onSignOutHandler}
              favouriteSaddleData={favouriteSaddleData}
            />
            <MdScreenButtons
              onSignInHandler={onSignInHandler}
              onSignUpHandler={onSignUpHandler}
              favouriteSaddleData={favouriteSaddleData}
            />
            <ToggleMobileMenu
              navRef={navRef}
              toggle={toggle}
              user={user}
              setToggle={setToggle}
              onSignUpHandler={onSignUpHandler}
              onSignInHandler={onSignInHandler}
              onSignOutHandler={onSignOutHandler}
            />
          </div>
        </div>
      </div>
      {showMegaMenu && (
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="absolute top-[70px] left-0 w-full z-20"
        >
          <MegaMenu onOptionClick={() => setShowMegaMenu(false)} />
        </div>
      )}
    </>
  );
};

export default Header;
